<template>
  <div class="taskinfo">
    <img
      class="fileicon"
      :title="taskFile"
      src="@/assets/img/device/file.png"
      alt="文件"
    />
    <div class="verticalline"></div>
    <div class="infocontent">
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.cutTime") }}</div>
        <div class="infonumber" :title="devicein.cutTime">{{ devicein.cutTime }}</div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.cutLength") }}</div>
        <div class="infonumber" :title="devicein.cutLeng">{{ devicein.cutLeng }}</div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.emptyLength") }}</div>
        <div class="infonumber" :title="devicein.emptyLength">
          {{ devicein.emptyLength }}
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.percent") }}</div>
        <div class="infonumber" :title="devicein.percent">{{ devicein.percent }}</div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.pierceCount") }}</div>
        <div class="infonumber" :title="devicein.pierceCount">
          {{ devicein.pierceCount }}
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.pierceDuration") }}</div>
        <div class="infonumber" :title="devicein.pierceTime">
          {{ devicein.pierceTime }}
        </div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.left") }}</div>
        <div class="infonumber" :title="devicein.left + '%'">{{ devicein.left }}%</div>
      </div>
      <div class="infoitems" :class="{ infoitemsMin: screenSize < 1200 }">
        <div class="infotitle">{{ $t("index.partCount") }}</div>
        <div class="infonumber" :title="devicein.partCount">{{ devicein.partCount }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const screenSize = ref();
const width = window.innerWidth;
screenSize.value = width;
const props = defineProps({
  devicein: { type: Object, required: true },
});

const taskFile = ref(props.devicein.taskFile);
</script>

<style scoped>
.taskinfo {
  width: 100%;
  display: flex;
  /* height: 380px; */
}
.fileicon {
  height: 200px;
  margin: auto 30px;
  cursor: pointer;
}
.verticalline {
  width: 1px;
  background-color: #e3e4e6;
  margin: 0px 30px;
}
.infocontent {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  align-items: center;
}
.infoitems {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  height: 80px;
  position: relative;
  text-align: left;
  border-radius: 4px;
  padding: 12px;
  width: 48%;
  text-decoration: none;
  background: #f7f9fa;
  border: 1px solid transparent;
  transition: all 0.1s linear;
  margin-right: 10px;
  margin-top: 10px;
}
.infoitemsMin {
  width: 100% !important;
  margin-top: 10px !important;
}
.infoitems:hover {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}
.infotitle {
  line-height: 18px;
  height: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  height: 18px;
}
.infonumber {
  display: block;
  line-height: 50px;
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
